module.exports = __webpack_public_path__ + "static/img/3_2_4_1.aad262ee.jpg";